module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isCheckbox(_vm.input)) ? _c('div', [_c('md-checkbox', {
    attrs: {
      "disabled": !_vm.edit
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, [_vm._v(_vm._s(_vm.input.label))]), _vm._v(" "), _c('span', {
    staticClass: "md-helper-text"
  }, [_vm._v(_vm._s(_vm.input.hint))])], 1) : _c('div', [_c('md-field', [_c('label', [_vm._v(_vm._s(_vm.input.label))]), _vm._v(" "), (_vm.input.options) ? _c('md-select', {
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.input.options), function(item) {
    return _c('md-option', {
      key: item.value,
      attrs: {
        "disabled": !_vm.edit,
        "required": _vm.input.required,
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.display || item.value))])
  })) : (_vm.input.multiline) ? _c('md-textarea', {
    staticClass: "md-primary",
    attrs: {
      "disabled": !_vm.edit,
      "required": _vm.input.required
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }) : _c('md-input', {
    staticClass: "md-primary",
    attrs: {
      "disabled": !_vm.edit,
      "required": _vm.input.required,
      "type": _vm.input.type
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-helper-text"
  }, [_vm._v(_vm._s(_vm.input.hint))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68757b18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/editField.vue
// module id = 452
// module chunks = 1